module.exports = __webpack_public_path__ + "img/dzpdf4.1be5beb8.png";